import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MonacoEditorLoaderService {
  loaded: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private zone: NgZone) {
  }

  public load() {
    return new Promise<void>((resolve) => {
      const baseUrl = './assets/monaco/min/vs';
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (typeof ((window as any).monaco as any) === 'object') {
        resolve();
        return;
      }

      const onGotAmdLoader = () => {
        // Load monaco
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).require.config({ paths: { vs: `${baseUrl}` } });
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).require(['vs/editor/editor.main'], () => {
          this.zone.run(() => {
            this.loaded.next(true);
            resolve();
          });
        });
      };

      // Load AMD loader if necessary
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (!(window as any).require) {
        const loaderScript: HTMLScriptElement = document.createElement('script');
        loaderScript.type = 'text/javascript';
        loaderScript.src = `${baseUrl}/loader.js`;
        loaderScript.addEventListener('load', onGotAmdLoader);
        document.body.appendChild(loaderScript);
      } else {
        onGotAmdLoader();
      }
    });
  }
}

